// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.3_webpack@5.99.9/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/chevron-down.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@disy/cadenza-icons/chevron-up.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@disy/cadenza-icons/error.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.summary,
.expanded-toggle {
  background: none;
  border: none;
  padding: 0;
  text-align: left;
}

:host(:not([non-toggleable])) :is(.summary,.expanded-toggle) {
    cursor: pointer;
  }

.expanded-toggle {
  aspect-ratio: 1;
  background: var(--color);
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  mask-position: center;
  mask-size: var(--space-5);
  width: var(--icon-size);
}

:host([expanded]) .expanded-toggle {
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }

.expanded-toggle:hover,.summary:hover ~ .expanded-toggle {
    background: var(--color-hover);
  }

.content[hidden] {
  height: 0;
  margin-top: 0;
}

:host([non-toggleable]) .summary-aside {
    margin-right: calc(-1 * var(--space-2));
  }

:host([non-toggleable]) .expanded-toggle {
    display: none;
  }

.summary {
  align-items: center;
  display: flex;
  gap: var(--space-05);
  min-width: 0;
}

:host(.has-error) .summary::after {
    aspect-ratio: 1;
    background-color: var(--color-error-06);
    content: '';
    height: var(--space-4);
    mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    mask-size: 100%;
  }
`, "",{"version":3,"sources":["webpack://./packages/ui/src/disclosure/disclosure.module.css"],"names":[],"mappings":"AAAA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAKlB;;AAHE;IACE,eAAe;EACjB;;AAGF;EACE,eAAe;EACf,wBAAwB;EACxB,mDAAwD;EACxD,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;AAUzB;;AARE;IACE,mDAAsD;EACxD;;AAEA;IAEE,8BAA8B;EAChC;;AAGF;EACE,SAAS;EACT,aAAa;AACf;;AAGE;IACE,uCAAuC;EACzC;;AAEA;IACE,aAAa;EACf;;AAGF;EACE,mBAAmB;EACnB,aAAa;EACb,oBAAoB;EACpB,YAAY;AAUd;;AARE;IACE,eAAe;IACf,uCAAuC;IACvC,WAAW;IACX,sBAAsB;IACtB,mDAAiD;IACjD,eAAe;EACjB","sourcesContent":[".summary,\n.expanded-toggle {\n  background: none;\n  border: none;\n  padding: 0;\n  text-align: left;\n\n  :host(:not([non-toggleable])) & {\n    cursor: pointer;\n  }\n}\n\n.expanded-toggle {\n  aspect-ratio: 1;\n  background: var(--color);\n  mask-image: url('~@disy/cadenza-icons/chevron-down.svg');\n  mask-position: center;\n  mask-size: var(--space-5);\n  width: var(--icon-size);\n\n  :host([expanded]) & {\n    mask-image: url('~@disy/cadenza-icons/chevron-up.svg');\n  }\n\n  &:hover,\n  .summary:hover ~ & {\n    background: var(--color-hover);\n  }\n}\n\n.content[hidden] {\n  height: 0;\n  margin-top: 0;\n}\n\n:host([non-toggleable]) {\n  .summary-aside {\n    margin-right: calc(-1 * var(--space-2));\n  }\n\n  .expanded-toggle {\n    display: none;\n  }\n}\n\n.summary {\n  align-items: center;\n  display: flex;\n  gap: var(--space-05);\n  min-width: 0;\n\n  :host(.has-error) &::after {\n    aspect-ratio: 1;\n    background-color: var(--color-error-06);\n    content: '';\n    height: var(--space-4);\n    mask-image: url('~@disy/cadenza-icons/error.svg');\n    mask-size: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
